export const resolveLabelFontSize = (theme, size) => {
  switch (size) {
    case 'small':
    case 'sm':
      return theme.tokens.ComponentTextInputLabelFontSizeSmall;
    case 'medium':
    case 'md':
      return theme.tokens.ComponentTextInputLabelFontSizeMedium;
    case 'large':
    case 'lg':
      return theme.tokens.ComponentTextInputLabelFontSizeLarge;
    default:
      return theme.tokens.ComponentTextInputLabelFontSizeMedium;
  }
};
const resolveAlignment = (alignment, layout) => {
  let currentAlignment;
  if (!alignment) {
    currentAlignment = layout === 'horizontal' ? 'right' : 'left';
  } else {
    currentAlignment = alignment;
  }
  return currentAlignment === 'left' ? 'flex-start' : 'flex-end';
};
export const inputLabelDefaultStyle = (theme, size, layout, displayLabel, alignment) => {
  return {
    '& .MuiInputLabel-asterisk': {
      visibility: 'hidden'
    },
    '&.MuiInputLabel-root': {
      color: theme.tokens.ComponentTextInputLabelColor,
      lineHeight: '115%',
      fontSize: resolveLabelFontSize(theme, size),
      fontWeight: theme.tokens.ComponentTextInputFontWeight,
      fontFamily: theme.tokens.ComponentTextInputFontFamily,
      WebkitTransform: 'none',
      transform: 'none',
      textOverflow: 'unset',
      whiteSpace: 'break-spaces',
      display: layout === 'horizontal' ? 'inline-flex' : 'flex',
      textAlign: 'left',
      justifyContent: resolveAlignment(alignment, layout),
      alignItems: 'center',
      alignContent: 'flex-end',
      alignSelf: 'center',
      ...(displayLabel ? {} : {
        display: 'none'
      })
    },
    width: '100%',
    padding: 0,
    paddingRight: layout === 'horizontal' ? '16px' : '4px'
  };
};